<template>
  <button v-ripple id="overview-button" class="overview-toggle needsclick" aria-label="Übersicht" aria-pressed="true" @click="buttonClick()">
    <svg width="100%" height="100%" viewBox="0 0 30 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
        <g transform="matrix(1,0,0,1,-40,-3944.44)">
            <g transform="matrix(1,0,0,1,0,3909.69)">
                <g transform="matrix(1,0,0,1,0,-23)">
                    <g transform="matrix(0.708335,0,0,0.666667,-1002.81,18.3333)">
                        <rect x="1483.47" y="59.5" width="30.997" height="6" style="fill:rgb(163,163,163);"/>
                    </g>
                    <g transform="matrix(0.708335,0,0,0.666667,-1002.81,26.3333)">
                        <rect x="1483.47" y="59.5" width="30.997" height="6" style="fill:rgb(163,163,163);"/>
                    </g>
                    <g transform="matrix(0.907466,0,0,0.907466,-1317.37,-60.0182)">
                        <circle cx="1498.26" cy="149.888" r="2.479" style="fill:rgb(163,163,163);"/>
                    </g>
                    <g transform="matrix(0.907466,0,0,0.907466,-1317.37,-68.0182)">
                        <circle cx="1498.26" cy="149.888" r="2.479" style="fill:rgb(163,163,163);"/>
                    </g>
                    <g transform="matrix(0.907466,0,0,0.907466,-1317.37,-76.0182)">
                        <circle cx="1498.26" cy="149.888" r="2.479" style="fill:rgb(163,163,163);"/>
                    </g>
                    <g transform="matrix(0.708335,0,0,0.666667,-1002.81,34.3333)">
                        <rect x="1483.47" y="59.5" width="30.997" height="6" style="fill:rgb(163,163,163);"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'OverviewToggle',
  methods: {
    buttonClick: function () {
      this.$emit('clicked')
    }
  }
}
</script>

<style scoped>
button {
  padding: 0;
  line-height: 0;
  cursor: pointer;
  border: none;
  background: transparent;
  background: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
#overview-button {
  height: 40px;
  width: 40px;
  margin-left: -8px;
  margin-right: 0px;
  position: relative;
  z-index: 2;
  border-radius:40px;
}
#overview-button svg {
  padding:8px;
}
@media(min-width:400px) {
  #overview-button {
    height: 50px;
    width: 50px;
    margin-left: -10px;
    margin-right: 2px;
  }
  #overview-button svg {
    padding: 10px;
  }
}
@media(min-width:767px) {
  #overview-button {
    margin-right: 16px;
  }
}
</style>
